import { render, staticRenderFns } from "./EditDynamicField.vue?vue&type=template&id=89fab3ce&"
import script from "./EditDynamicField.vue?vue&type=script&lang=js&"
export * from "./EditDynamicField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports